if (!customElements.get('catalog-mega')) {
  class CatalogMega extends HTMLElement {
    connectedCallback() {
      this.onPointer = (event) => {
        const link = event.target.closest('.catalog-mega__link[data-menu]');
        if (!link || !this.contains(link)) return;
        this.activate(link.getAttribute('data-menu'));
      };
      this.addEventListener('mouseover', this.onPointer);
      this.addEventListener('focusin', this.onPointer);
    }

    activate(handle) {
      if (!handle) return;
      this.querySelectorAll('.catalog-mega__link[data-menu]').forEach((link) => {
        link.classList.toggle('nav__main-menu-link--active', link.getAttribute('data-menu') === handle);
      });
      this.querySelectorAll('.catalog-mega__products[data-menu]').forEach((panel) => {
        const active = panel.getAttribute('data-menu') === handle;
        panel.classList.toggle('active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.querySelectorAll('.catalog-mega__view[data-menu]').forEach((view) => {
        view.classList.toggle('is-active', view.getAttribute('data-menu') === handle);
      });
    }
  }

  customElements.define('catalog-mega', CatalogMega);
}
